import { createRoot } from "react-dom/client";
import type { ReactNode } from "react";

export type IslandRenderer = (props: unknown) => ReactNode;

/** Props JSON d'un îlot (écrites par island_props() côté Twig), ou null si absentes ou illisibles. */
export function readIslandProps(el: Element): unknown | null {
  const script = el.querySelector('script[type="application/json"][data-island-props]');
  if (!script?.textContent) return null;
  try {
    return JSON.parse(script.textContent);
  } catch {
    return null;
  }
}

/**
 * Monte chaque `[data-island]` connu du registre. Pas d'hydratation : le contenu
 * rendu par le serveur reste affiché jusqu'au montage, puis React le remplace.
 * Un îlot inconnu, sans props lisibles ou déjà monté est laissé tel quel.
 */
export function mountIslands(registry: Record<string, IslandRenderer>, root: ParentNode = document): number {
  let mounted = 0;
  root.querySelectorAll<HTMLElement>("[data-island]").forEach((el) => {
    const render = registry[el.dataset.island ?? ""];
    if (!render || el.dataset.islandMounted === "1") return;
    const props = readIslandProps(el);
    if (props === null) return;
    el.dataset.islandMounted = "1";
    createRoot(el).render(render(props));
    mounted++;
  });
  return mounted;
}

/** Lance `fn` quand le navigateur est libre, après le premier affichage. */
export function whenIdle(fn: () => void): void {
  const ric = (window as Window & { requestIdleCallback?: (cb: () => void) => number }).requestIdleCallback;
  if (ric) ric(fn);
  else window.setTimeout(fn, 1);
}
